module.exports = __webpack_public_path__ + "img/草苁蓉.70a39dac.jpg";